export const SET_TRIP = 'SET_TRIP'
export const SET_TRAVELER_STATUS = 'SET_TRAVELER_STATUS'
